'use client'

import { SITE_NAME, STARKEY_LOGO_DARK, STARKEY_LOGO_LIGHT, SUPRA_LOGO_DARK, SUPRA_LOGO_LIGHT } from '@/constants'
import { useTheme } from 'next-themes'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

const BrandLogo = (): React.ReactElement => {
  const pathname = usePathname()
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  const supraFullLogo = mounted && resolvedTheme === 'light' ? SUPRA_LOGO_LIGHT : SUPRA_LOGO_DARK
  const starKeyFullLogo = mounted && resolvedTheme === 'light' ? STARKEY_LOGO_DARK : STARKEY_LOGO_LIGHT
  const brandFullLogo = pathname?.startsWith('/starKey-wallet') ? starKeyFullLogo : supraFullLogo

  return <Image src={brandFullLogo} alt={SITE_NAME} width={200} height={50} className="h-10 w-30" />
}

export default BrandLogo
